import { useMemo } from 'react';
import { useLocation } from 'react-router';

interface Location {
  path: string;
  exact: boolean;
}

export function useShowSidebar(): boolean {
  const { pathname } = useLocation();
  const showSidebar = useMemo(shouldShowSidebar, [pathname]);

  function shouldShowSidebar(): boolean {
    const publicLocations: Location[] = [
      { path: '/', exact: true },
      { path: '/auth', exact: true },
      { path: '/widget', exact: false }
    ];
    return !publicLocations.some((location) => {
      if (location.exact) {
        return pathname === location.path;
      }
      return pathname.includes(location.path);
    });
  }

  return showSidebar;
}
